import { render, staticRenderFns } from "./ProjectResultConfigItemChildList.vue?vue&type=template&id=054071c4&scoped=true"
import script from "./ProjectResultConfigItemChildList.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfigItemChildList.vue?vue&type=script&lang=js"
import style0 from "./ProjectResultConfigItemChildList.vue?vue&type=style&index=0&id=054071c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054071c4",
  null
  
)

export default component.exports